const initialState = {
  searchFlightsResultPersonalizedRoundTrip: null,
  searchFlightsResultPersonalizedOneWay: null,
  searchFlightsResultPersonalizedMultipleDestination: null,
};

const searchFlightsResultPersonalized = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PERSONALIZED_SEARCH':
      return {
        // initialState = action.payload
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export default searchFlightsResultPersonalized;
